// // axios
// import axios from 'axios'

// const baseURL =import.meta.env.VITE_API_URL

// export default axios.create({
//   baseURL: baseURL,

//   // You can add your headers here
// })
import axios from 'axios'

// Create instances for different API endpoints
const createAxiosInstance = (baseURL) => {
  return axios.create({
    baseURL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

// Create separate instances for different purposes
const apiInstance = createAxiosInstance(import.meta.env.VITE_EPROFIL_API_URL)
// const authInstance = createAxiosInstance(import.meta.env.VITE_AUTH_API_URL)
const systemInstance = createAxiosInstance(import.meta.env.VITE_API_URL)

// Add interceptors to all instances
const addInterceptors = (instance) => {
  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        console.log('Unauthorized, redirecting...')
        // Add your redirect logic here
      }
      return Promise.reject(error)
    }
  )
}

// Apply interceptors to all instances
addInterceptors(apiInstance)
// addInterceptors(authInstance)
addInterceptors(systemInstance)

// Export all instances
export const api = apiInstance
// export const auth = authInstance
export const system = systemInstance

// Default export for backward compatibility
export default apiInstance
